import axios from 'axios';
import authService from './authService';

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://dev-sakti.gbs.id/api/insight';

// Create axios instance with base URL
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor
api.interceptors.request.use(
    config => {
        // Get token from local storage
        const token = authService.getToken();

        // If token exists, add to Authorization header
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },
    error => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    }
);

// Add a response interceptor
api.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // Handle 401 Unauthorized errors (expired or invalid token)
        if (error.response && error.response.status === 401) {
            // Logout user and redirect to login page
            authService.logout();
            window.location.href = '/login';
            return Promise.reject(error);
        }
        // Handle 403 Forbidden -> redirect to forbidden page
        if (error.response && error.response.status === 403) {
            window.location.href = '/403';
            return Promise.reject(error);
        }
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
    }
);

export default api;
